export enum ErrorMessages {
  DateIsLocked = 'qwgG',
  ScannedCodeCanNotLocated = 'Rz+s',
  AtLeastOneQuantityOrderedGreaterThanZero = 'WlQu',
  AtLeastOneQuantityOrderedMustHaveValueOtherThanZero = 'KWFV',
  AtLeastOneQuantityReceivedMustHaveValue = 'cfIm',
  ReceivedUnitCostMustHaveValue = 'gcjA',
  QuantityReceivedAndReceivedUnitCostRequired = 'Y5tO',
  OneDateCannotBeEarlierThanAnother = '/yTp',
  OneDateCannotBeLaterThanAnother = 'bn0c',
  FieldIsRequired = 'x9/y',
  EnterAnAmountWithUpToDecimalPlaces = 'kvlf',
  TransactionFailedPlsTryAgain = 'n0Ta',
  YouCanOnlyOperateUpToMaxCountRecords = 'VMPr',
  CheckInternetAndTryAgain = '5l6W',
  BulkOperationFailed = 'YCtt',
  FailedToDo = 'MR8d',
  InvalidValue = 'U6aX',
  TransferNoSelectedToSitesError = 'iW+8',
  SiteInUseInventoryCountError = '5NwS',
  NotAssignedToSelectSites = 'PlV3',
  ItemNotExist = 'lw76',
  TransferUnitNotExist = 'zswL',
  TransferNoQuantityItemsError = 'RoIx',
  FailedToDoAndWhy = 'C5yb',
  ValueShouldNotBeGreaterThanExpected = '6w/R',
  PartialBulkFailedPlsTryAgain = '4QbP',
  AtLeastOneTransferShouldBeInANewState = 'KM0j',
  SpecialCharactersAreNotAllowed = 'dx+9',
  NoAvailableTransferToPrintWrittenSheet = 'tXHb',
  NoAvailableTransferForExportOrPrint = 'z4iu',
  FromSiteNotAvailableErrorMessage = '+WWB',
  EmailIsNotValid = '8mpx',
  UrlFormatIsNotCorrect = 'Kq0T',
  InvalidLanguageCode = 'aHgv',
  ValueShouldBeAtLeastExpected = 'tqjf',
  ValueShouldBeMoreThanExpected = '7+0G',
  ValueShouldBeLessThanExpected = 'CM0Y',
  ValueShouldBeExpected = 'CM0Y5',
  YearIsNotValid = 'LXOx',
  TimeIsNotValid = 'hs5V',
  FieldNeedsToBeAtLeastExpected = '7boO',
  FieldNeedsToBeNoLongerThanExpected = 'gpXl',
  FieldNeedsToBeAtLeastExpectedWithTrim = 'qfQO',
  ArrayFieldNeedsToBeAtLeastExpected = 'pdTM',
  ArrayFieldNeedsToBeNoLongerThanExpected = 'urK9',
  JsonParseIsNotValid = '48Sl',
  JsonCompileIsNotValid = 'gfL4',
  InvalidNumericValue = '0cxe',
  InvalidDateSelected = 'E1VX',
  AtLeastOneFieldOfExpectedShouldBeFilledIn = 'GZcA',
  ValuesShouldBeSelected = 'EOjo',
  ValueShouldBeSelected = 'f7AV',
  NotUnique = 'lAH9',
  FollowingItemsNotAllowed = 'vTYq',
  TypeMismatchError = 'ioxi',
  RowStartDateShouldBeLessThanEndDate = '8aad',
  IPAddressIsNotValid = 'ozSM',
  CheckHighlightedMinAndMaxValueRows = 'NE8v',
  HighlightedRowsValueShouldEqualZeroOrGreater = 'aHqn',
  OpenTimeCanNotBeGreaterThanCloseTime = 'sf/0',
  EndTimeMustGreaterThanStartTime = 'gRGf',
  PeriodNeedsToHaveBothStartAndEndTime = 'N5RP',
  StartDateCannotGreaterThanEndDate = 'By81',
  KeyShouldBeUnique = 'ULk8',
  DaypartsOverlap = 'Wm3S',
  TimePeriodDaysNotContained = 'lg7Y',
  DaypartsAreNotContiguous = 'pxdX',
  ValueDoesNotMatchRegularExpression = 'c06D',
  NotAbleToValidateField = 'FRKe',
  RangeEndCannotBeLessThanRangeStart = 'nr+g',
  ValueShouldBeUnique = '+DnL',
  PleaseAddAtLeastOneOption = 'rXSW',
  PeriodTypeOptionsShouldBeSelected = 'BSnL',
  PleaseAssignDefaultIdentificationMethod = 'pv8U',
  UrlIsNotUnique = 'gU+j',
  FieldValueIsNotNumber = 'V1PA',
  RangeStartShouldNotBeGreaterThanRangeEnd = 'kxXh',
  EachSetShouldHaveAName = 'I2uV',
  AtLeastOneSetShouldBePresent = 'qv4X',
  TransferSiteSameError = 'RyI1',
  APIRequestTimeoutTitle = 'F/p5',
  XVIAPIRequestError = 'VV54',
  BulkReplenishNoAvailableMessage = 'iwfC',
  EventNoAssignmentSiteError = 'J5AV',
  Page404 = 'x91r',
  ThePageYouAreLookingForCannotBeFound = 'wtq1',
  UnexpectedError = 'cROt',
  UnexpectedErrorOccurs = 'Ld8v',
  NotPermitted = 'jsX0',
  YouAreNotPermittedToDoThis = 'NQXl',
  CanNotReceivePreferencesForCurrentCompany = 'jgQ6',
  SomeRoutesCanNotBeUnreachable = 'FAS6',
  GoToCompanyPreferencesAndTrySave = 'RXZ0',
  API_REQUEST_TIMEOUT = 'F/p5f',
  NotAssignedToSites = 'JY4T',
  SiteAssignmentRequired = 'zwU3',
  MissingFollowingPermissions = '790Q',
  YouAreMissingTheFollowingPermissions = 'isJi',
  YouAreMissingTheFollowingPermission = 'swlt',
  EndingCountIsRequired = 'dffG',
  SingleTransferVoidFailed = 'vdNT',
  PartialTransferVoidFailed = 'UOND',
  StandWorksheetCannotBeReopenedBecauseTheAssociatedEventIsClosed = 'naUG',

  PartialTransfersFailedToBePleaseCheck = 'Au6x',
  UniquenessFieldCombinationError = 'xZDN',
  IncorrectUrlMessage = 'UkLW',
  ActionCannotBeDoneMessage = '+YrD',
  NoAvailablePAR = 'VZPS',
  NoAvailableMin = 'eCdN',
  NoActiveSiteError = 'fdNr',

  InternetConnectionIsAbsent = 'NE9b',
  CONNECTION_ERROR = 'hpec',

  ValueAlreadyInUse = 'RjsW',
  NotConfiguredError = 'LiHQ',

  ViewOperationFailed = 'wREy',

  UnableToAccessClipboard = 'FqCP',
  CouldNotConnectToEntity = 'RBcx',

  needPermissionToView = '+vgY',

  HawkerCommissaryAssignmentDuplicate = 'SfNi',

  QtyReturnedExceedsQtyRequested = '090e',
  ActionFailedPlsTryAgain = 'w3Bh',
  TotalQtyReturnedExceedsTotalQtyRequested = 'ZbmZ',
  ProductNotRequested = 'RSwP',
  QtyRequestedAndQtyReturnedAreRequired = '12wi',
}
